import { createMask } from 'imask';
import { NationalIdType } from '../../../types';

const CONFIG = new Map<string, { types: NationalIdType[]; currentMask?: string; currentCode: string } | undefined>();

export const nationalIdUtil = {
  setup(
    fieldName: string,
    currentCode: string,
    types: NationalIdType[]
  ): { currentMask?: string; hasValidUntilDate?: boolean } {
    const currentType = types.find((type) => type.code === currentCode) ?? undefined;
    CONFIG.set(fieldName, {
      types,
      currentMask: currentType?.masks?.length === 1 ? currentType?.masks[0] : undefined,
      currentCode
    });

    // If the field is primaryNationalIdentification, we need to set the config for
    // personPrimaryNationalIdentification as is used by the isValid function below.
    // This workaround is required as the primaryNationalIdentification is mapped to
    // personPrimaryNationalIdentificationMetadata in PersonSmartformElements.
    if (fieldName === 'primaryNationalIdentification') {
      CONFIG.set('personPrimaryNationalIdentification', {
        types,
        currentMask: currentType?.masks?.length === 1 ? currentType?.masks[0] : undefined,
        currentCode
      });
    }

    return {
      currentMask: currentType?.masks?.length === 1 ? currentType?.masks[0] : undefined,
      hasValidUntilDate: currentType?.hasValidUntilDate
    };
  },

  isValid(fieldName: string, value?: string): boolean {
    const config = CONFIG.get(fieldName);
    // Without a resolved mask (e.g. the national id types are still loading) there is nothing to validate against.
    // Throwing here would abort the whole schema validation and drop every other error with it.
    if (!config?.currentMask) {
      return true;
    }
    const maskedValue = createMask({
      mask: config.currentMask
    });
    maskedValue.resolve(value ?? '');
    return maskedValue.isComplete;
  }
};
